import { render, staticRenderFns } from "./DaysSelectbox.vue?vue&type=template&id=0a272e76"
import script from "./DaysSelectbox.vue?vue&type=script&lang=js"
export * from "./DaysSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports